/* Guarda contra o listener ser anexado mais de uma vez: o editor de temas
   recarrega a seção via AJAX a cada configuração alterada, o que injeta e
   executa esta tag <script> de novo sem recarregar a página. Sem essa
   guarda, dois listeners idênticos alternam a classe "is-expanded" duas
   vezes no mesmo clique — abre e fecha na mesma hora, parecendo que o
   clique "não funciona". */
if (!window.itgCaptionToggleBound) {
  window.itgCaptionToggleBound = true;

  document.addEventListener('click', function (event) {
    var caption = event.target.closest('[data-grid-caption]');
    if (!caption) return;

    var expanded = caption.classList.toggle('is-expanded');
    caption.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
}
